export function goToMsLogin() {
  const url = '/api/v1/oauth/redirect?provider=ms'
  window.location.href = url
}

const INTRANET_SIGN_STORAGE_KEY = 'INTRANET_SIGN_STORAGE_KEY'

export function isLastSignIntranet() {
  return localStorage.getItem(INTRANET_SIGN_STORAGE_KEY)
}

export function setLastSignIntranet(value) {
  localStorage.setItem(INTRANET_SIGN_STORAGE_KEY, value)
}
